<template>
  <div>
    <v-text-field     
      :class="css"       
      :disabled="dis"
      v-model="selectedValue"
      @input="onSelect()"
      :outlined="outlined"
      :dense="dense"
      :rules="emailRules"
    />
    <!-- <span v-if="!isValidate == true" style="color:red">{{
      $t("errors.Invalid_Email")
    }}</span> -->
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  props: [
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam",
    "css",
    "outlined",
    "dense",
    "isRequired"        
  ],
  data(){
    return{
      selectedValue: this.value,    
      expression:"^(([^<>()[\\]\\.,;:\\s@]+(\\.[^<>()[\\]\\.,;:\\s@]+)*)|(.+))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$", 
      emailRules:[
        v => !this.isRequired || (!!v || ''),
        v => (!this.isRequired && (!v || v.trim().length == 0)) || 
        (new RegExp(this.expression)).test(v) || 
        this.$t("errors.Invalid_Email")
      ]
    }  
  },
  computed: {
    isValidate() {
      return this.validateEmail();
    }
  },
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  },
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        return;
      }
      var isvalidemail = this.validateEmail
      if (isvalidemail) {
        this.$emit("input", this.selectedValue);
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalidemail);
      } catch (e) {
        // ignore
      }
    },
    validateEmail() {      
      if (!this.selectedValue) {        
        return true;
      } else {    
        return (new RegExp(this.expression)).test(this.selectedValue);
      }
    },
    onCopyFrom() {
      try {
        this.selectedValue = this.copyfrom_sourcefield;
        this.$emit("input", this.selectedValue);
      } catch (e) {
        // ignore
      }
    }
  } 
};
</script>
